// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"uVgDp","richHeading":"ImLHU","customHeading":"lnEk-","richBody":"nvVXm","richLegal":"afj8J"};